module.exports = __webpack_public_path__ + "img/f34.e05de967.png";